import {Stack} from '@mui/material';
import {PrimaryButton, SectionTitle, SuccessButton, TariffDate, TariffTitle} from '../profile.styles';

interface Props {
  tariffTitle: string;
  tariffEndDate: string;
  onOpenTariffs: () => void;
  onOpenBalance: () => void;
}

export const TariffSection = ({tariffTitle, tariffEndDate, onOpenTariffs, onOpenBalance}: Props) => {
  return (
    <Stack gap="10px">
      <SectionTitle>Ваш тарифный план</SectionTitle>
      <TariffTitle>{tariffTitle}</TariffTitle>
      <TariffDate>{`Действует до ${tariffEndDate}`}</TariffDate>
      <Stack direction={{xs: 'column', md: 'row'}} gap="40px" mt="4px">
        <PrimaryButton variant="contained" onClick={onOpenTariffs}>
          Изменить тариф
        </PrimaryButton>
        <SuccessButton variant="contained" onClick={onOpenBalance}>
          Пополнить баланс
        </SuccessButton>
      </Stack>
    </Stack>
  );
};
